export default __webpack_public_path__ + "static/media/yellowCircle.52b53660.svg";